import { Injectable } from '@angular/core';
import { LookupModel, LookupsClient, UpdateTypeClient, UpdateTypeConnectionsModel, UpdateTypeModel } from '@core/services/api.service';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { catchError, tap } from 'rxjs/operators';
import { LoadFrequencyUpdateAction, LoadFrequencyUpdateFailAction, LoadFrequencyUpdateSuccessAction, LoadUpdateTypeConnectionAction, LoadUpdateTypeConnectionFailAction, LoadUpdateTypeConnectionSuccessAction, LoadUpdateTypesAction, LoadUpdateTypesByParentIdAction, LoadUpdateTypesByParentIdFailAction, LoadUpdateTypesByParentIdSuccessAction, LoadUpdateTypesFailAction, LoadUpdateTypesSuccessAction } from './update-type.actions';
import { stat } from 'fs';

export class UpdateTypeStateModel {
    public showMenu: boolean;
    public isMobileMode: boolean;
    public showSpinner: boolean;
    public updateTypes: UpdateTypeModel[];
    public frequencyUpdateTypes: LookupModel[];
    public updateTypeConnections: UpdateTypeConnectionsModel[];

}

@State<UpdateTypeStateModel>({
    name: 'updateType',
    defaults: {
        showMenu: true,
        isMobileMode: false,
        showSpinner: false,
        updateTypes: undefined,
        frequencyUpdateTypes: undefined,
        updateTypeConnections: undefined,
    }
})
@Injectable()
export class UpdateTypeState {
    constructor(private updateTypeClient: UpdateTypeClient, private lookUpClient: LookupsClient) {}


    @Selector()
    static getUpdateTypes(state: UpdateTypeStateModel) {
      return state.updateTypes;
    }

    @Selector()
    static getFrequencyUpdateTypes(state: UpdateTypeStateModel){
        return state.frequencyUpdateTypes;
    }


    @Selector()
    static getUpdateTypeConnections(state: UpdateTypeStateModel) {
      return state.updateTypeConnections;
    }


    @Action(LoadUpdateTypesAction)
    LoadUpdateTypesAction({ dispatch, patchState }: StateContext<UpdateTypeStateModel>, action: LoadUpdateTypesAction) {
      patchState({ showSpinner: true });

      return this.updateTypeClient.getUpdateTypes().pipe(
        tap((updateType) => dispatch(new LoadUpdateTypesSuccessAction({ updateType }))),
        catchError((err) => dispatch(new LoadUpdateTypesFailAction()))
      );
    }

    @Action(LoadUpdateTypesSuccessAction)
    LoadDepartmentsSuccessAction(ctx: StateContext<UpdateTypeStateModel>, action: LoadUpdateTypesSuccessAction) {
      ctx.patchState({
        showSpinner: false,
        updateTypes: action.payload.updateType
      });
    }

    @Action(LoadUpdateTypesFailAction)
    LoadDepartmentsFailAction(ctx: StateContext<UpdateTypeStateModel>, action: LoadUpdateTypesFailAction) {
      ctx.patchState({
        showSpinner: false,
        updateTypes: undefined
      });
    }

    //-------------------------------

    @Action(LoadFrequencyUpdateAction)
    LoadFrequencyUpdateAction({ dispatch, patchState }: StateContext<UpdateTypeStateModel>, action: LoadFrequencyUpdateAction) {
      patchState({ showSpinner: true });

      return this.lookUpClient.getFrequencyUpdateTypes().pipe(
        tap((frequencyUpdateTypes) => dispatch(new LoadFrequencyUpdateSuccessAction({ frequencyUpdateTypes }))),
        catchError((err) => dispatch(new LoadFrequencyUpdateFailAction()))
      );
    }

    @Action(LoadFrequencyUpdateSuccessAction)
    LoadFrequencyUpdateSuccessAction(ctx: StateContext<UpdateTypeStateModel>, action: LoadFrequencyUpdateSuccessAction) {
      ctx.patchState({
        showSpinner: false,
        frequencyUpdateTypes: action.payload.frequencyUpdateTypes
      });
    }

    @Action(LoadFrequencyUpdateFailAction)
    LoadFrequencyUpdateFailAction(ctx: StateContext<UpdateTypeStateModel>, action: LoadFrequencyUpdateFailAction) {
      ctx.patchState({
        showSpinner: false,
        frequencyUpdateTypes: undefined
      });
    }

    //-------------------------------

    @Action(LoadUpdateTypesByParentIdAction)
    LoadUpdateTypesByParentIdAction({ dispatch, patchState }: StateContext<UpdateTypeStateModel>, action: LoadUpdateTypesByParentIdAction) {
      patchState({ showSpinner: true });

      return this.updateTypeClient.getUpdateTypeConnectionsByParentId(action.payload.parentId).pipe(
        tap((updateTypeConnection) => dispatch(new LoadUpdateTypesByParentIdSuccessAction({updateTypeConnection}))),
        catchError((err) => dispatch(new LoadUpdateTypesByParentIdFailAction()))
      );
    }

    @Action(LoadUpdateTypesByParentIdSuccessAction)
    LoadUpdateTypesByParentIdSuccessAction(ctx: StateContext<UpdateTypeStateModel>, action: LoadUpdateTypesByParentIdSuccessAction) {
      ctx.patchState({
        showSpinner: false,
        updateTypeConnections: action.payload.updateTypeConnection
      });
    }

    @Action(LoadUpdateTypesByParentIdFailAction)
    LoadUpdateTypesByParentIdFailAction(ctx: StateContext<UpdateTypeStateModel>, action: LoadUpdateTypesByParentIdFailAction) {
      ctx.patchState({
        showSpinner: false,
        updateTypeConnections: undefined
      });
    }

    //-------------------------------------

    @Action(LoadUpdateTypeConnectionAction)
    LoadUpdateTypeConnectionAction({ dispatch, patchState }: StateContext<UpdateTypeStateModel>, action: LoadUpdateTypeConnectionAction) {
      patchState({ showSpinner: true });

      return this.updateTypeClient.getUpdateTypeConnections().pipe(
        tap((updateTypesConnections) => dispatch(new LoadUpdateTypeConnectionSuccessAction({updateTypesConnections}))),
        catchError((err) => dispatch(new LoadUpdateTypeConnectionFailAction()))
      );
    }

    @Action(LoadUpdateTypeConnectionSuccessAction)
    LoadUpdateTypeConnectionSuccessAction(ctx: StateContext<UpdateTypeStateModel>, action: LoadUpdateTypeConnectionSuccessAction) {
      ctx.patchState({
        showSpinner: false,
        updateTypeConnections: action.payload.updateTypesConnections
      });
    }

    @Action(LoadUpdateTypeConnectionFailAction)
    LoadUpdateTypeConnectionFailAction(ctx: StateContext<UpdateTypeStateModel>, action: LoadUpdateTypeConnectionFailAction) {
      ctx.patchState({
        showSpinner: false,
        updateTypeConnections: undefined
      });
    }

}
